import React, {
  MutableRefObject,
  RefObject,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import * as _ from 'lodash';
import styled from 'styled-components';
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Row,
  Tooltip,
  Typography,
} from 'antd';
import { ReactComponent as IssuanceTicketIcon } from 'app/assets/img/issuance-ticket-icon.svg';
import { ReactComponent as IssuanceTicketIconInactive } from 'app/assets/img/issuance-ticket-icon-inactive.svg';

import { ReactComponent as TicketUpgradeIcon } from 'app/assets/img/ticket-upgrade-icon.svg';
import { ReactComponent as TicketUpgradeIconInactive } from 'app/assets/img/ticket-upgrade-icon-inactive.svg';

import { ReactComponent as TicketRefundIcon } from 'app/assets/img/ticket-refund-icon.svg';
import { ReactComponent as TicketRefundIconnInactive } from 'app/assets/img/ticket-refund-icon-inactive.svg';

import { ReactComponent as CancelTicketIcon } from 'app/assets/img/cancel-ticket-issuance-icon.svg';
import { ReactComponent as CancelTicketIconInactive } from 'app/assets/img/cancel-ticket-issuance-icon-inactive.svg';
import { ReactComponent as ExportTicketIcon } from 'app/assets/img/export-excel-icon.svg';
import { ReactComponent as ExportTicketIconInactive } from 'app/assets/img/export-excel-icon-inactive.svg';
import { ReactComponent as SynTicketIcon } from 'app/assets/img/ticket-syn-icon.svg';
import { ReactComponent as SynTicketIconInactive } from 'app/assets/img/ticket-syn-icon-inactive.svg';
import StyledButton from 'app/components/StyledButton';
import useWindowSize from 'app/hooks/useWindowSize';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { Permission } from 'app/hooks/usePermission';
import { BP_TYPE } from 'utils/constants';
type SearchComponentProps = {
  handleCancelTicket: () => void;
  onOpenCustomerInfo: (params: any, type: string) => void;
  handleExportExcel: () => void;
  device?: string;
  selectedTicketRef?: any;
  handleSynTicketStatus: () => void;
  disabledAllAction?: boolean;
  onUpgradeTicket: () => void;
  onRefundTicket: () => void;
};

export const ActionComponent = ({
  handleCancelTicket,
  onOpenCustomerInfo,
  handleExportExcel,
  onUpgradeTicket,
  device,
  selectedTicketRef,
  handleSynTicketStatus,
  disabledAllAction,
  onRefundTicket,
}: SearchComponentProps) => {
  const translations = useSelector(selectTranslations);
  const userInfo = useSelector(selectInfoUser);
  const isProxyBuyer =
    (userInfo?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
  return (
    <>
      <div
        style={{
          display: 'flex',
          marginBottom: 24,
          marginTop: device === 'desktop' ? 15 : 10,
          marginLeft: device === 'desktop' ? 0 : 8,
          justifyContent: 'space-between',
          overflow: 'auto',
        }}
      >
        <div style={{ display: 'flex' }}>
          <Button
            onClick={e =>
              disabledAllAction ? e.preventDefault() : handleSynTicketStatus()
            }
            style={{
              display: 'flex',
              marginRight: device === 'desktop' ? 15 : 8,
              cursor: disabledAllAction ? 'not-allowed' : 'pointer',
              border: device === 'desktop' ? 'none' : '1px solid #EDEDED',
              borderRadius: 10,
              minWidth: 41,
              boxShadow: 'none',
              height: 41,
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              whiteSpace: 'no-wrap',
            }}
            disabled={disabledAllAction}
          >
            {device === 'desktop' ? (
              <SynTicketIcon style={{ marginBottom: 3 }} />
            ) : (
              <Tooltip
                title={translations ? translations['b2b.txt.syn-status'] : ''}
                placement="bottom"
              >
                <SynTicketIcon width={16} height={16} />
              </Tooltip>
            )}

            {device === 'desktop' && (
              <Typography
                style={{
                  color: disabledAllAction ? '#808080' : '#FAB317',
                  marginLeft: 5,
                }}
              >
                {translations ? translations['b2b.txt.syn-status'] : ''}
              </Typography>
            )}
          </Button>
          <Button
            onClick={e =>
              disabledAllAction
                ? e.preventDefault()
                : onOpenCustomerInfo(null, 'release')
            }
            style={{
              display: isProxyBuyer ? 'none' : 'flex',
              marginRight: device === 'desktop' ? 15 : 8,
              cursor: disabledAllAction ? 'not-allowed' : 'pointer',
              border: device === 'desktop' ? 'none' : '1px solid #EDEDED',
              borderRadius: 10,
              boxShadow: 'none',
              minWidth: 41,
              height: 41,
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              whiteSpace: 'no-wrap',
            }}
            disabled={disabledAllAction}
          >
            {device === 'desktop' ? (
              <IssuanceTicketIcon style={{ marginBottom: 3 }} />
            ) : (
              <Tooltip
                title={
                  translations ? translations['b2b.txt.ticket-issuance'] : ''
                }
                placement="bottom"
              >
                <IssuanceTicketIcon width={16} height={16} />
              </Tooltip>
            )}
            {device === 'desktop' && (
              <Typography
                style={{
                  color: disabledAllAction ? '#808080' : '#FAB317',
                  marginLeft: 5,
                }}
              >
                {translations ? translations['b2b.txt.ticket-issuance'] : ''}
              </Typography>
            )}
          </Button>
          {userInfo?.businessPartner?.allowChangeTicket && (
            <Button
              onClick={e =>
                disabledAllAction ? e.preventDefault() : onUpgradeTicket()
              }
              style={{
                display: 'flex',
                marginRight: device === 'desktop' ? 15 : 8,
                cursor: disabledAllAction ? 'not-allowed' : 'pointer',
                border: device === 'desktop' ? 'none' : '1px solid #EDEDED',
                borderRadius: 10,
                boxShadow: 'none',
                minWidth: 41,
                height: 41,
                alignItems: 'center',
                justifyContent: 'center',
                padding: 10,
                whiteSpace: 'no-wrap',
              }}
              disabled={disabledAllAction}
            >
              {device === 'desktop' ? (
                <TicketUpgradeIcon style={{ marginBottom: 3 }} />
              ) : (
                <Tooltip
                  title={
                    translations ? translations['b2b.txt.ticket-exchange'] : ''
                  }
                  placement="bottom"
                >
                  <TicketUpgradeIcon width={16} height={16} />
                </Tooltip>
              )}
              {device === 'desktop' && (
                <Typography
                  style={{
                    color: disabledAllAction ? '#808080' : '#FAB317',
                    marginLeft: 5,
                  }}
                >
                  {translations ? translations['b2b.txt.ticket-exchange'] : ''}
                </Typography>
              )}
            </Button>
          )}
          {userInfo?.businessPartner?.allowReturnTicket && (
            <Button
              onClick={e =>
                disabledAllAction ? e.preventDefault() : onRefundTicket()
              }
              style={{
                display: 'flex',
                marginRight: device === 'desktop' ? 15 : 8,
                cursor: disabledAllAction ? 'not-allowed' : 'pointer',
                border: device === 'desktop' ? 'none' : '1px solid #EDEDED',
                borderRadius: 10,
                boxShadow: 'none',
                minWidth: 41,
                height: 41,
                alignItems: 'center',
                justifyContent: 'center',
                padding: 10,
                whiteSpace: 'no-wrap',
              }}
              disabled={disabledAllAction}
            >
              {device === 'desktop' ? (
                <TicketRefundIcon style={{ marginBottom: 3 }} />
              ) : (
                <Tooltip
                  title={
                    translations ? translations['b2b.txt.ticket-rollback'] : ''
                  }
                  placement="bottom"
                >
                  <TicketRefundIcon width={16} height={16} />
                </Tooltip>
              )}
              {device === 'desktop' && (
                <Typography
                  style={{
                    color: disabledAllAction ? '#808080' : '#FAB317',
                    marginLeft: 5,
                  }}
                >
                  {translations ? translations['b2b.txt.ticket-rollback'] : ''}
                </Typography>
              )}
            </Button>
          )}
        </div>
        <div style={{ display: 'flex' }}>
          <Button
            style={{
              display: 'flex',
              marginRight: device === 'desktop' ? 15 : 8,
              cursor: disabledAllAction ? 'not-allowed' : 'pointer',
              border: device === 'desktop' ? 'none' : '1px solid #EDEDED',
              boxShadow: 'none',
              borderRadius: 10,
              minWidth: 41,
              height: 41,
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
            }}
            disabled={disabledAllAction}
            onClick={e =>
              disabledAllAction ? e.preventDefault() : handleExportExcel()
            }
          >
            {device === 'desktop' ? (
              <ExportTicketIcon style={{ marginBottom: 3 }} />
            ) : (
              <Tooltip
                title={translations ? translations['b2b.txt.export-excel'] : ''}
                placement="bottom"
              >
                <ExportTicketIcon width={16} height={16} />
              </Tooltip>
            )}
            {device === 'desktop' && (
              <Typography
                style={{
                  color: disabledAllAction ? '#808080' : '#FAB317',
                  marginLeft: 5,
                }}
              >
                {translations ? translations['b2b.txt.export-excel'] : ''}
              </Typography>
            )}
          </Button>
        </div>
      </div>
    </>
  );
};
